import FrontShopModal from "./FrontShopModal";
import ClinicModal from "./ClinicModal";
import DispensaryModal from "./DispensaryModal";
import modalStyles from "../../../../css/modal.module.css";

export default function ExpiredStockModal({ isModalOpen, setIsModalOpen, selectedRow, activeSegment, roleId, onPullFromInventory }) {
  if (!isModalOpen || !selectedRow) return null;

  const renderModalContent = () => {
    // Primary decision: actual record type
    if (selectedRow.drug) {
      // Drug record -> use Dispensary-style view
      return <DispensaryModal selectedRow={selectedRow} roleId={roleId} onPullFromInventory={onPullFromInventory} />;
    }
    if (selectedRow.item) {
      // Item/Front-shop record -> use Front Shop-style view
      return <FrontShopModal selectedRow={selectedRow} roleId={roleId} onPullFromInventory={onPullFromInventory} />;
    }

    // Fallback: use active segment if type not clearly resolved
    if (activeSegment === "Clinic") {
      return <ClinicModal selectedRow={selectedRow} roleId={roleId} onPullFromInventory={onPullFromInventory} />;
    }
    if (activeSegment === "Front Shop") {
      return <FrontShopModal selectedRow={selectedRow} roleId={roleId} onPullFromInventory={onPullFromInventory} />;
    }

    // Default fallback: Dispensary-style
    return <DispensaryModal selectedRow={selectedRow} roleId={roleId} onPullFromInventory={onPullFromInventory} />;
  };

  return (
    <div className={modalStyles.modalPopup} onClick={() => setIsModalOpen(false)}>
      <div className={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button
          className={modalStyles.closeBtn}
          onClick={() => setIsModalOpen(false)}
          aria-label="Close"
        >
          ×
        </button>

        {renderModalContent()}
      </div>
    </div>
  );
}
